module.exports = __webpack_public_path__ + "down-arrow.svg?586f24dba2dd9b5652466634bc7fe347";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/down-arrow.svg
// module id = 135
// module chunks = 0